import { useSelector } from 'react-redux'
import isEqual from 'lodash/isEqual'

import { RootState } from 'types'

export const useHeaders = () => useSelector(({ headers }: RootState) => headers, isEqual)
